import { useState } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { useUser } from '../../contexts/UserContext'
import Sidebar from './Sidebar'
import MobileHeader from './MobileHeader'
import SubRequestBanner from './SubRequestBanner'

/**
 * AppLayout - Main layout wrapper for authenticated pages
 *
 * Provides:
 * - Persistent sidebar on desktop (lg+)
 * - Mobile header with hamburger menu
 * - Sub request banner (when applicable)
 * - Main content area with proper spacing
 */
export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { isAuthenticated } = useUser()

  if (!isAuthenticated) {
    return <Outlet />
  }

  return (
    <div className="min-h-screen bg-slate-100">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Mobile Header */}
      <MobileHeader onMenuClick={() => setSidebarOpen(true)} />

      {/* Main Content */}
      <main className="lg:ml-64 min-h-screen">
        {/* Spacer for mobile header */}
        <div className="h-14 lg:h-0" />

        {/* Content Container */}
        <div className="p-4 lg:p-6">
          {/* Sub Request Banner - shows when there are open sub requests */}
          <SubRequestBanner />

          <Outlet />
        </div>
      </main>
    </div>
  )
}
